import {AutoDeliveryDcxActiveInfoBox} from '@/views/AutoDeliveryDcx/AutoDeliveryDcxActive/AutoDeliveryDcxActiveInfoBox';

import AutoDeliveryDcxDetailsDesktop from '../components/AutoDeliveryDcxDetailsDesktop';
import useAutoDeliveryDcxDetails from '../hooks/useAutoDeliveryDcxDetails';
import StatusActiveRescheduleButton from './StatusActiveRescheduleButton';
import StatusActiveSkipButton from './StatusActiveSkipButton';

const StatusActiveDesktop = () => {
    const details = useAutoDeliveryDcxDetails();
    const {
        autoDelivery: {isFreezed},
    } = details;

    return (
        <AutoDeliveryDcxDetailsDesktop
            status='active'
            extraSection={<AutoDeliveryDcxActiveInfoBox className='mt-4 bg-romance' details={details} />}
            showNextDeliveryHero
            footerActions={
                !isFreezed ? (
                    <>
                        <StatusActiveRescheduleButton className='mt-0 w-full' />
                        <StatusActiveSkipButton className='mt-0 w-full border-2 border-primary-dark-85' />
                    </>
                ) : undefined
            }
        />
    );
};

export default StatusActiveDesktop;
